import { Place, PlaceService } from '@/types/state/shared';

/**
 * The single definition of what `ss` picks, shared by `deriveStepSelection` (guards) and
 * `useBookingFlowSelection` (hydration), like `resolveEmployeeFromUrl` owns `sr`. Ids that
 * resolve to add-on-flagged services are dropped — `ss` carries main services only (add-ons
 * travel in `rs`), and a stale URL whose service was reclassified as an add-on must read as
 * "nothing picked" or the step machine has no main service to exit on.
 */
export function resolveMainServicesFromUrl(ss: string | undefined, place: Place): PlaceService[] {
  if (!ss) return [];
  const ids = ss.split(',').map((id) => parseInt(id, 10));
  return (place.services ?? [])
    .flatMap((category) => category.services ?? [])
    .filter((service) => service.id != null && ids.includes(service.id) && !service.about?.settings?.isAddOn);
}
